import {
  Button as Base,
  ButtonProps as BaseProps,
  Tooltip,
} from "@mui/material";

export type ButtonProps = Omit<BaseProps, "disableElevation"> & {
  disabledReason?: string;
};

export default function Button({
  disabledReason,
  disabled,
  ...rest
}: ButtonProps) {
  // The wrapping `<div>` exists so Tooltip has a non-disabled element to
  // anchor pointer events (disabled buttons don't fire mouse events). Without
  // an explicit width when `fullWidth` is set, the div sized to its natural
  // inline-block width while the inner Base button stretched to `width:
  // 100%`, overflowing tight parents on mobile. Mirror the button's width
  // intent on the div so the chain stays inside its container.
  const wrapperStyle: React.CSSProperties = rest.fullWidth
    ? { display: "block", width: "100%", maxWidth: "100%" }
    : { display: "inline-block", maxWidth: "100%" };
  return (
    // the tooltip is disabled when the button is enabled
    <Tooltip title={disabledReason || ""}>
      <div style={wrapperStyle}>
        <Base {...rest} disabled={disabled} disableElevation />
      </div>
    </Tooltip>
  );
}
